import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "disabled", "readOnly", "name", "value", "onChange", "checked"];
import React, { forwardRef } from 'react';
import { Radio as RebassRadio } from '@rebass/forms';
import Label from '../Label';
var Radio = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      checked = _ref.checked,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Label, _extends({
    ref: ref,
    color: "inherit",
    alignItems: "center"
  }, rest), /*#__PURE__*/React.createElement(RebassRadio, {
    name: name,
    value: value,
    disabled: disabled,
    checked: checked,
    readOnly: readOnly,
    onChange: onChange
  }), label);
});
Radio.displayName = 'Radio';
export default Radio;